var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisputeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7438_29480)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7438_29480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7143 25.4269L4.85712 27.1412L6.5714 21.9983V6.56975C6.5714 6.1151 6.75201 5.67906 7.07351 5.35757C7.395 5.03608 7.83103 4.85547 8.28569 4.85547H25.4285C25.8832 4.85547 26.3192 5.03608 26.6407 5.35757C26.9622 5.67906 27.1428 6.1151 27.1428 6.56975V23.7126C27.1428 24.1673 26.9622 24.6033 26.6407 24.9248C26.3192 25.2463 25.8832 25.4269 25.4285 25.4269H11.7143Z",
    stroke: "#7E00C4",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8571 9.14062V14.2835",
    stroke: "#7E00C4",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8571 20.2846C17.3305 20.2846 17.7143 19.9008 17.7143 19.4275C17.7143 18.9541 17.3305 18.5703 16.8571 18.5703C16.3838 18.5703 16 18.9541 16 19.4275C16 19.9008 16.3838 20.2846 16.8571 20.2846Z",
    stroke: "#7E00C4",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7438_29480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7438_29480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeActive);
export default __webpack_public_path__ + "static/media/disputeActive.cc40bd39d2596166bfa689d28783e23e.svg";
export { ForwardRef as ReactComponent };